import Container from 'react-bootstrap/Container'
import SnackCardContent from './components/SnackCardContent/SnackCardContent'
import SnackCardImg from './components/SnackCardImg/SnackCardImg'
import hocSnackCard from './hocSnackCard'

import gtmAddMealVoucher from 'services/gtm/gtmAddMealVoucher'
import gtmRemoveMealVoucher from 'services/gtm/gtmRemoveMealVoucher'
import './SnackCard.scss'

const SnackCard = ({ title, description, price, cardAmount, postMealVoucher, cinemaid, voucherid }) => {
    const amount = cardAmount ? Number(cardAmount) : 0

    const setAmount = (newAmount) => {
        if (newAmount - amount > 0) {
            gtmAddMealVoucher(voucherid, title, price)
        }
        if (newAmount - amount < 0) {
            gtmRemoveMealVoucher(voucherid, title, price)
        }
        postMealVoucher({ cinemaid, vouchers: [{ voucherid, amount: newAmount }] })
    }

    return (
        <Container fluid className="snack-card d-flex">
            <SnackCardImg voucherid={voucherid} name={'popcorn-menu'} />
            <SnackCardContent
                title={title}
                description={description}
                price={price}
                quantity={amount}
                setQuantity={setAmount}
            />
        </Container>
    )
}

export default hocSnackCard(SnackCard)
